const EXTERNAL_LINK_SELECTOR = 'a[target="_blank"]';
const ENHANCED_ATTRIBUTE = 'data-new-window-enhanced';
const INDICATOR_CLASS = 'external-link-indicator';
const SCREEN_READER_CLASS = 'external-link-copy';
const SCREEN_READER_TEXT = ' (opens in new window)';

let externalLinkObserver;

function ensureRel(link) {
  const relTokens = new Set(
    (link.getAttribute('rel') || '')
      .split(/\s+/)
      .filter(Boolean)
  );

  relTokens.add('noopener');
  relTokens.add('noreferrer');

  link.setAttribute('rel', Array.from(relTokens).join(' '));
}

function appendIndicator(link) {
  if (link.querySelector(`.${INDICATOR_CLASS}`)) {
    return;
  }

  const indicator = document.createElement('span');
  indicator.className = INDICATOR_CLASS;
  indicator.setAttribute('aria-hidden', 'true');
  link.append(indicator);
}

function appendScreenReaderCopy(link) {
  const ariaLabel = link.getAttribute('aria-label');

  if (ariaLabel) {
    if (!/opens in new window/i.test(ariaLabel)) {
      link.setAttribute('aria-label', `${ariaLabel}${SCREEN_READER_TEXT}`);
    }
    return;
  }

  if (link.querySelector(`.${SCREEN_READER_CLASS}`)) {
    return;
  }

  const copy = document.createElement('span');
  copy.className = `sr-only ${SCREEN_READER_CLASS}`;
  copy.textContent = SCREEN_READER_TEXT;
  link.append(copy);
}

function enhanceLink(link) {
  if (!(link instanceof HTMLAnchorElement) || link.getAttribute(ENHANCED_ATTRIBUTE) === 'true') {
    return;
  }

  appendIndicator(link);
  appendScreenReaderCopy(link);
  ensureRel(link);
  link.setAttribute(ENHANCED_ATTRIBUTE, 'true');
}

function enhanceExternalLinks(root = document) {
  if (root instanceof Element && root.matches(EXTERNAL_LINK_SELECTOR)) {
    enhanceLink(root);
  }

  if (typeof root.querySelectorAll !== 'function') {
    return;
  }

  root.querySelectorAll(EXTERNAL_LINK_SELECTOR).forEach(enhanceLink);
}

function observeExternalLinks() {
  if (externalLinkObserver || !document.body) {
    return;
  }

  externalLinkObserver = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }

        enhanceExternalLinks(node);
      });
    });
  });

  externalLinkObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function initExternalLinks() {
  enhanceExternalLinks(document);
  observeExternalLinks();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initExternalLinks, { once: true });
} else {
  initExternalLinks();
}

export { enhanceExternalLinks, initExternalLinks };